// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1M1pE","title":"InfoRow_title__6Wyh_"};